const JsonLd = ({ schema }: { schema: string }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: typeof window !== 'undefined' ? ' ' : schema }}
  />
)

export default JsonLd
